import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CleaningResultsDialogComponent } from '../cleaning-results-dialog/cleaning-results-dialog.component';

export interface CleaningSnackbarData {
  message: string;
  type: 'info' | 'success';
  showViewResults?: boolean;
  responseData?: any;
  projectId?: string;
  projectName?: string;
}

@Component({
  selector: 'app-cleaning-snackbar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="cleaning-snackbar-content">
      <span class="message">{{ data.message }}</span>
      <div class="actions">
        <button *ngIf="data.showViewResults" 
                mat-button 
                class="view-results-btn"
                (click)="onViewResults()">
          Download Results
        </button>
        <button mat-icon-button 
                class="close-btn"
                (click)="dismiss()"
                aria-label="Close">
          <span class="close-x">×</span>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .cleaning-snackbar-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      gap: 16px;
    }

    .message {
      flex: 1;
      color: white;
      text-align: center;
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .view-results-btn {
      color: white !important;
      font-size: 14px !important;
      font-weight: 500 !important;
    }

    .close-btn {
      color: white !important;
      width: 32px !important;
      height: 32px !important;
      padding: 0 !important;
      min-width: 32px !important;
    }

    .close-x {
      font-size: 32px !important;
      font-weight: 300 !important;
      line-height: 1 !important;
    }
  `]
})
export class CleaningSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: CleaningSnackbarData,
    private snackBarRef: MatSnackBarRef<CleaningSnackbarComponent>,
    private dialog: MatDialog
  ) {}

  onViewResults(): void {
    // Dismiss the snackbar
    this.snackBarRef.dismiss();
    
    // Open the results dialog
    if (this.data.responseData && this.data.projectName && this.data.projectId) {
      this.dialog.open(CleaningResultsDialogComponent, {
        width: '500px',
        data: {
          projectId: this.data.projectId,
          projectName: this.data.projectName,
          responseData: this.data.responseData
        }
      });
    }
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
